import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/fastvaluedeal-faq';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';

const ICON_MINUS = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /></svg>`;

const ICON_PLUS = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>`;

const faqItem = (question, answer) => `
    <div data-attribute="item-wapper" class="item-wapper">
      <div data-attribute="item-question" class="item-question">
        <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question">
          ${question}
        </h3>
        <span data-attribute="icon-minus" style="display: none">${ICON_MINUS}</span>
        <span data-attribute="icon-plus">${ICON_PLUS}</span>
      </div>
      <div data-attribute="item-answer" class="item-answer">
        <div data-attribute="answer-content" class="answer-content">${answer}</div>
      </div>
    </div>`;

const faqItems = [
  {
    question: 'Are There Any Fees To Pay?',
    answer:
      '<p><span style="color:hsl( 0, 1%, 46% );">No, the only payment you will have to make is when purchasing WaveMax. No additional fees are applicable.</span></p>',
  },
  {
    question: 'Is There An Available Channel List?',
    answer:
      '<p><span style="color:hsl( 0, 1%, 46% );">The WaveMax antenna scans the area around you and broadcasts any channel signal it picks up. The list is automatically updated every time the television set is turned on.</span></p>',
  },
  {
    question: 'Will It Work With My TV?',
    answer:
      '<p><span style="color:hsl( 0, 1%, 46% );">The WaveMax antenna has two plug options, making it compatible with any television set.</span></p>',
  },
  {
    question: 'Are All Channels In HD?',
    answer:
      '<p><span style="color:hsl( 0, 1%, 46% );">While WaveMax provides the best quality broadcast possible, it does depend on the signal strength of each individual channel.</span></p>',
  },
  {
    question: 'Is It Legal?',
    answer:
      '<p><span style="color:hsl( 0, 1%, 46% );">Yes, WaveMax and the technology used are completely legal and safe to use.</span></p>',
  },
  {
    question: 'Other Usage-related Questions',
    answer: `
          <p><span style="color:hsl( 0, 1%, 46% );"><strong>Can I switch it between TV sets?</strong></span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );">Yes, WaveMax is completely portable.</span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );"><strong>Are there stand options?</strong></span></p> 
          <p>
            <span style="color:hsl( 0, 1%, 46% );" >
               The foot WaveMax comes with can be used as a regular stand or as an adhesive holder on the side of furniture or walls.
            </span>
          </p>
          <p><span style="color:hsl( 0, 1%, 46% );"><strong>Will my cable provider sue me?</strong></span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );">No, WaveMax is completely legal and won't lead to any lawsuits.</span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );"><strong>Can I take it on a flight?</strong></span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );">Yes, WaveMax is perfectly safe to bring onto a plane.</span></p> 
          <p><span style="color:hsl( 0, 1%, 46% );"><strong>How is it installed?</strong></span></p> 
          <p>
            <span style="color:hsl( 0, 1%, 46% );">All you have to do to set WaveMax up is plug it into your television
            set and turn it on. That's it!</span>
          </p>`,
  },
];

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 100,
  height: 6,
  align: 'center',
  backgroundColor: '#5b04de',
});

const html = `
<div
  data-attribute="faq-grid-container"
  class="faq-grid-container container"
  data-container-full-width="true"
>
  <div data-attribute="title-faq-grid" class="title-faq-grid">
    <h2 style="text-align: center">
      <strong>Frequently Asked Questions</strong>
    </h2>
  </div>
  ${dividerPrimaryHtml}
  <div data-attribute="list-item" class="list-item">
    ${faqItems.map(({ question, answer }) => faqItem(question, answer)).join('')}
  </div>
</div>
`;

export default containerFuild(html, css);
